export const ua = {
  LANGUAGES: {
    TITLE: 'Мови',
    English: 'Англійська',
    Russian: 'Російська',
    Ukrainian: 'Українська',
    German: 'Німецька',
  },
  PAGES: {
    HOME: {
      SEARCH: {
        HINT: 'Напиши, яку історію, світ чи персонажа ти хочеш знайти',
      },
      TRENDING: {
        TITLE: 'Популярне за останні 14 днів',
      },
    },
    CHAT_HISTORY: {
      YOUR_PREVIOUS_CONVERSATION: 'Ваші попередні чати',
      SEARCH_BY_NAME: 'Пошук за назвою',
      PLACEHOLDER_TITLE: 'За вашим запитом нічого не знайдено',
      PLACEHOLDER_TEXT: 'Спробуйте змінити параметри пошуку',
      EMPTY: {
        TITLE: 'У вас поки немає активних чатів',
        TEXT: 'Оберіть пригоду з десятків тисяч або створіть власну',
        CREATE_CHATBOT: 'Створити чат-бота',
        GO_TO_CATALOG: 'Перейти до каталогу',
      },
    },
    SMART_SEARCH: {
      HEADING: 'Знайди свою пригоду',
      SEARCH_PLACEHOLDER: 'Пошук нової пригоди',
      TOOLTIP: {
        ENABLED: {
          TITLE: 'Розумний пошук: увімкнено',
          TEXT: 'Семантичний пошук за змістом',
        },
        DISABLED: {
          TITLE: 'Розумний пошук: вимкнено',
          TEXT: 'Просте збігання за текстом',
        },
        NOT_AVAILABLE: {
          TITLE: 'Помилка голосового введення',
          TEXT: 'Перевірте налаштування доступу в браузері або справність пристрою введення',
        },
      },
      LOADER_STEPS: {
        0: 'Запускаємо пошук...',
        1: 'Відкриваємо індекс персонажів...',
        2: 'Обираємо відповідні типи...',
        3: "Переконуємо їх з'явитися...",
        4: 'Відсіваємо нудних, майже готово...',
      },
    },
    SUBSCRIBE: {
      SUBSCRIBE: 'Підписка',
      PICK_THE_PLAN: 'Виберіть план або купіть токени',
      UPGRADE_YOUR_EXPERIENCE: 'Покращіть свій досвід і розкрийте уяву з преміум-функціями',
      BUY_TOKENS: 'Купити токени',
      APPLY: 'Застосувати',
      PROMO_CODE: 'Промокод',
      PLANS: 'Плани',
      TOKENS: 'Токени',
      CODE_APPLIED: 'Код застосовано',
      PROMOTIONAL_CODE: 'Введіть промокод',
      DISCOUNT: '+{{discount}}% до депозиту',
      COMPARE_CAICHAT_FEATURE: 'Порівняйте функції {{brandShort}}',
      NO_ADS: 'Без реклами',
      SKIP_QUEUES: 'Без черг',
      CONTEXTUAL_MEMORY_4K: "Контекстна пам'ять до 4K токенів (приблизно 42 повідомлення)",
      ACCESS_MEMORY_MANAGER: "Доступ до менеджера пам'яті",
      CUSTOM_PERSONAS_10: 'До 10 користувацьких персон',
      CONTEXTUAL_MEMORY_8K: "Контекстна пам'ять до 8K токенів (приблизно 84 повідомлення)",
      SEMANTIC_MEMORY_2: "Семантична пам'ять 2.0: автоматичне збереження та використання спогадів",
      EXTENDED_RESPONSES: 'Розширені відповіді до 300 токенів',
      IMAGE_GENERATION: 'Генерація зображень у діалозі',
      ACCESS_AI_MODELS: 'Доступ до додаткових моделей ШІ',
      CUSTOM_PERSONAS_50: 'До 50 користувацьких персон',
      CONTEXTUAL_MEMORY_16K: "Контекстна пам'ять до 16K токенів (приблизно 168 повідомлень)",
      PRIORITY_GENERATION: 'Пріоритет у генерації відповідей',
      ACCESS_ADVANCED_MODELS: 'Доступ до просунутих моделей ШІ',
      IMAGE_GENERATION_ALL: 'Генерація зображень для всіх персонажів, включно з приватними',
      TEXT_TO_SPEECH: 'Функція перетворення тексту в мовлення (голосові відповіді)',
      CUSTOM_PERSONAS_100: 'До 100 користувацьких персон',
      HAVE_PROMO_CODE: 'У вас є промокод?',
      APPLY_PROMO_CODE: 'Застосуйте промокод і отримайте бонус при купівлі токенів або підписки',
      TOKENS_PACK: {
        POPULAR: 'Популярний',
        SPECIAL_SALE: 'Спеціальний розпродаж',
        STANDARD_PACKS: 'Стандартні пакети',
        SPECIAL_OFFER: 'Спеціальна пропозиція',
      },
    },
    MY_PROFILE: {
      MY_PROFILE: 'Мій профіль',
      SETTINGS: 'Налаштування',
      LOG_OUT: 'Вийти',
      TITLE: 'Тримайтеся міцніше!\nВаша особиста панель керування готується!',
      TEXT: 'Наша команда наполегливо працює над тим, щоб створити для вас надзвичайно зручний особистий кабінет.\nНезабаром ви зможете переглядати детальну статистику, відстежувати витрати та доходи, а також багато іншого.\nСлідкуйте за оновленнями!',
      TABS: {
        REFERRAL: 'Реферальна програма',
        MONETIZATION: 'Монетизація',
        PURCHASE_HISTORY: 'Історія покупок',
        BALANCE_HISTORY: 'Історія балансу',
        AI_MODELS: 'AI Моделі',
      },
    },
    MY_PERSONAS: {
      PLACEHOLDER_1: 'У вас ще немає персона.',
      PLACEHOLDER_2: 'Створіть нову.',
      CREATE_PERSONA: 'Створити нову персону',
    },
    CREATE_PERSONA: {
      PERSONA: 'Персона',
      NAME_PLACEHOLDER: 'Введіть ім’я вашої персони',
      DESCRIPTION: 'Опис',
      DESCRIPTION_PLACEHOLDER: 'Як би ваша персона описала себе?',
      DESCRIPTION_INFO: 'Використовується лише у ваших розмовах для надання контексту ШІ. Будьте лаконічними (1-2 речення).',
      VISIBILITY: 'Видимість',
      PUBLIC: 'Публічна',
      PRIVATE: 'Приватна',
      CHECKBOX: 'Встановити як персону за замовчуванням',
      ALREADY_DEFAULT: 'Вже персона за замовчуванням',
      NAME: 'Ім’я персони',
      SUCCESSFULLY_CREATED: 'Персона успішно створена',
      SUCCESSFULLY_UPDATED: 'Персона успішно оновлена',
      NO_SPACE_FOR_NEW_PERSONAS: 'Ви не зможете створювати нових персон, поки не звільните місце',
    },
    MY_CHATBOTS: {
      NO_CHATBOTS: 'Ви ще не створили жодного чат-бота!',
      DO_IT_NOW: 'Зробіть це зараз!',
    },
    MY_GAMES: {
      TITLE: 'Мої ігри',
      SUBTITLE: 'Керування ігровими розширеннями',
      SEARCH_PLACEHOLDER: 'Пошук ігор...',
      LOADING: 'Завантаження...',
      NO_GAMES: 'Ви ще не створили жодної гри',
      NO_SEARCH_RESULTS: 'Ігор не знайдено',
      WORKFLOWS: '{{ count }} сценаріїв',
      STORAGES: '{{ count }} сховищ',
      LOADING_EXTENSION: 'Завантаження гри...',
      LOADING_WORKFLOW: 'Завантаження сценарію...',
      STARTING_GAME: 'Запуск...',
      FINISHED: 'Завершено',
      RESTART: 'Грати знову',
      RETRY: 'Повторити',
      ERROR: 'Помилка',
      LOAD_FAILED: 'Не вдалося завантажити',
      INVALID_ID: 'Невірний ID гри',
      NO_WORKFLOW: 'Сценарій не знайдено',
      NO_NODES: 'Сценарій не містить вузлів',
      JUST_NOW: 'щойно',
      MINUTES_AGO: '{{ count }} хв. тому',
      HOURS_AGO: '{{ count }} год. тому',
      DAYS_AGO: '{{ count }} д. тому',
    },
    CHARACTERS: {
      NO_CHARACTERS: 'За вашим запитом нічого не знайдено',
      FILTERS: 'Спробуйте змінити параметри пошуку або створіть власного чатбота',
    },
    PUBLIC_PROFILE: {
      NO_CHATBOTS: 'У цього користувача наразі немає чатботів',
      TRY_LATTER: 'Спробуйте повернутися пізніше',
    },
    FAVORITES: {
      NO_FAVORITES: 'У вас поки немає чатботів у вибраному',
      GO_AND_ADD: 'Перейдіть до каталогу та додайте чатботів у вибране, натиснувши кнопку',
      PURCHASE_HISTORY: 'Історія покупок',
      BALANCE_HISTORY: 'Історія балансу',
      MONETIZATION: 'Монетизація',
    },
    CHATBOT_CREATE: {
      UPLOADING: 'Завантаження',
      MODEL_AND_PROMPT: 'Оберіть модель ШІ та її поведінку',
      IMPORT_CHATBOT: 'Імпортувати чат-бота',
      CHATBOT_NAME: 'Ім’я чат-бота',
      CHATBOT_DESCRIPTION: 'Опис чат-бота',
      CHATBOT_AVATAR: 'Аватар чат-бота',
      UPLOAD_IMAGE_FOR_CHATBOT: 'Завантажити зображення для чат-бота',
      CREATE_CHATBOT: 'Створити чат-бота',
      START_CHAT: 'Почати розмову',
      SAVE_CHANGES: 'Зберегти зміни',
      AGREEMENT_TEXT: 'Я прочитав та погоджуюсь з',
      COMMUNITY_GUIDELINES: 'Правилами спільноти',
      MESSAGE_COST: 'Вартість повідомлення',
      GENDER: 'Стать',
      VISIBILITY: 'Видимість',
      ADD_TAGS: 'Додати теги',
      SEARCH_TAGS: 'Пошук тегів',
      NAME_PLACEHOLDER: 'Введіть ім’я чат-бота',
      DESCRIPTION_PLACEHOLDER:
        'Короткий опис чат-бота, який відображатиметься в каталозі та превʼю.<br><br>Не впливає на памʼять або поведінку.',
      CREATE_NEW_CHATBOT: 'Створити нового чат-бота',
      EDIT_CHATBOT: 'Редагувати чат-бота',
      CHATBOT_PROFILE: 'Профіль чат-бота',
      GUIDE: 'Читати посібник',
      READ_CREATION_GUIDE: 'Прочитайте наш посібник зі створення чат-ботів',
      STATS_TITLE: 'Статистика',
      HAS_BEEN_STARTED: 'Дата початку:',
      USER_MESSAGES: 'Повідомлень користувача:',
      CHARACTER_MESSAGES: 'Повідомлень чат-бота:',
      USER_WORDS: 'Слів користувача:',
      CHARACTER_WORDS: 'Слів чат-бота:',
      FILL_REQUIRED_FIELDS: "Необхідно заповнити обов'язкові поля!",
      MALE: 'Чоловічий',
      FEMALE: 'Жіночий',
      NON_BINARY: 'Небінарний',
      OTHER: 'Інший',
      NOT_SPECIFIED: 'Не вказано',
      PUBLIC: 'Публічний',
      PRIVATE: 'Приватний',
      VISIBLE_TOOLTIP: 'Публічний — видимий для всіх. Приватний — видимий лише автору цього чат-бота.',
      AI_TOOLTIP:
        'Модель ШІ: програма, навчена розуміти та генерувати текст як людина.\n\nПоведінка: стиль оповіді та вказівка ШІ щодо того, як він має поводитися.',
      NO_ONLY_EMOJI: "Ім'я не може складатися лише з емодзі",
      COST_DEPENDS: 'Вартість залежить від різних параметрів: Модель, Поведінка, Вітання, Сценарій.',
      PRICE_1_MESSAGE: 'Ціна за 1 повідомлення:',
      NOT_AVAILABLE: {
        TITLE: 'Це приватний чатбот',
        TEXT: 'Ви намагаєтеся отримати доступ до посилання на чатбота, доступ до якого обмежено його автором. Ви не можете переглядати або взаємодіяти з цим чатботом.',
        GO_HOME: 'На головну сторінку',
      },
      OTHER_CHATBOTS_BY_AUTHOR: 'Інші боти цього автора',
      SIMILAR_CHATBOTS: 'Схожі боти',
      ACCESS_ONLY_LINK: 'Доступ до нього можливий лише\n за посиланням автора.',
      PERSONAL_CHARACTER: 'Це особистий персонаж',
      DEFINITION: 'Визначення',
      ALLOW_PROXIES: 'Дозволити проксі',
      DEFINITION_DESCRIPTION: 'Користувачі зможуть бачити особистість і сценарій.',
      ALLOW_PROXIES_DESCRIPTION: 'Користувачі зможуть використовувати проксі-сервіси для взаємодії з вашим ботом.',
      ADDITIONAL_SETTINGS: 'Додаткові налаштування',
      SETTINGS: 'Налаштування',
      ALLOW_REPLACEMENT: 'Користувацькі моделі',
      ALLOW_REPLACEMENT_DESCRIPTION: 'Користувачі зможуть використовувати особисті моделі для спілкування з ботом.',
      SHOW_NOTES_FIRST: 'Показувати першими',
      SHOW_NOTES_FIRST_DESCRIPTION:
        'При відкритті чат-бота користувачі спочатку побачать ваші авторські нотатки, а потім перше повідомлення.',
      EDIT: 'Редагувати',
    },
  },
  MODALS: {
    PROMO_CODE: {
      HAVE_PROMO_CODE: 'У вас є промокод?',
      APPLY_TO_RECEIVE: 'Використайте його, щоб отримати бонус',
      ENTER_CODE: 'Введіть промокод',
      CODE_APPLIED: 'Промокод застосовано',
      APPLY: 'Застосувати',
      PROMO_BONUS:
        'Бонус промокоду: <span class="bg-gradient-to-r from-[#F372FF] from-[18.1%] to-[#FFD153] to-[90.98%] bg-clip-text text-transparent font-extrabold">+{{tokens}}</span> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="size-4 inline-block"><path d="M12.4137 5.51725H8.63443L12.1379 0H7.72409L3.58618 8.27588H6.84137L3.58618 16L12.4137 5.51725Z" fill="#ff9f32"/></svg> за підписку або {{bonusPercent}}% бонусних токенів до пакетів токенів',
      PREV_ACTIVE: 'Ви вже застосовували реферальний код раніше',
      VALIDATION_ERROR: 'Промокод має містити рівно {{length}} символів і включати лише A-Z та 0-9.',
      NO_CODE: 'Реферальний код не знайдено або він неактивний',
    },
    UPGRADE_SUGGESTION: {
      BANNER: 'ПОСПІШАЙТЕ!',
      TITLE:
        'Заощадьте <span class="bg-gradient-to-r from-[#F372FF] from-[18.1%] to-[#FFD153] to-[90.98%] bg-clip-text text-transparent">{{percent}}%</span> на Нескінченних історіях',
      TEXT: 'Відкрий розумну памʼять, генерацію зображень і глибші розмови',
      PER_YEAR: '/рік',
      PER_MONTH: '/міс',
      ENHANCED_MEMORY_TITLE: 'Покращена памʼять',
      ENHANCED_MEMORY_DESCRIPTION: 'Ваша історія зберігається повністю — від початку до кінця',
      UNLIMITED_IMAGE_GENERATION_TITLE: 'Необмежена генерація зображень',
      UNLIMITED_IMAGE_GENERATION_DESCRIPTION: 'Створюйте сцени та персонажів без обмежень',
      RICHER_ROLEPLAY_TITLE: 'Більш насичений рольовий відіграш',
      RICHER_ROLEPLAY_DESCRIPTION: 'Глибші історії, виразніші персонажі',
      UNLOCK: 'ПОКРАЩИТИ МОЮ ІСТОРІЮ — ЗНИЖКА ДО {{percent}}%',
      UNLOCK_MOBILE: 'ПОКРАЩИТИ МОЮ ІСТОРІЮ',
      MAYBE_LATER: 'Можливо пізніше',
    },
    UNLOCK_VOICEOVER: {
      TITLE: 'Дайте персонажам голос',
      TEXT_1:
        'Наша функція озвучення доступна лише для тарифного плану <span class="bg-gradient-to-r from-[#F372FF] from-[18.1%] to-[#FFD153] to-[90.98%] bg-clip-text text-transparent font-extrabold">{{plan}}</span>.',
      TEXT_2:
        'Не просто читайте історію — проживіть її. Оновіться до <span class="font-semibold">{{plan}}</span> і <span class="bg-gradient-to-r from-[#F372FF] from-[18.1%] to-[#FFD153] to-[90.98%] bg-clip-text text-transparent font-extrabold">розблокуйте високоякісне озвучення</span>. Слухайте унікальні <span class="bg-gradient-to-r from-[#F372FF] from-[18.1%] to-[#FFD153] to-[90.98%] bg-clip-text text-transparent font-extrabold">інтонації, емоції та шепіт</span> ваших улюблених персонажів, коли вони відповідають вам у реальному часі.',
    },
    CHAT_QUERY: {
      WAIT_TITLE: 'Очікування затягнулося',
      WAIT_TIME: 'Орієнтовний час очікування',
      POSITION: 'Позиція в черзі',
      QUEUE_INFO: 'Ми прагнемо забезпечити максимальний комфорт для всіх користувачів, тому в години пік може виникати черга.',
      SUBSCRIPTION_INFO: 'Підтримка через підписку дозволяє нам продовжувати покращення, а ви можете спілкуватися без черг!',
      UPGRADE: 'Пропустіть чергу з підпискою',
      CANCEL: 'Перервати генерацію',
      LESS_THAN_MINUTE: 'Менше хвилини',
      ABOUT_MINUTE: 'Близько хвилини',
      ONE_TWO_MINUTES: 'Одна–дві хвилини',
      SEVERAL_MINUTES: 'Кілька хвилин',
    },
    MODEL_SETTINGS: {
      TITLE: 'Налаштування моделі',
      ADVANCED_SETTINGS: 'Розширені налаштування',
      APPLY_SETTINGS: 'Застосувати налаштування',
    },
    GENERATE_IMAGE: {
      GENERATE_BACKGROUND: 'Згенерувати фон',
      GENERATE_AVATAR: 'Згенерувати аватар',
      GENERATE_IMAGE: 'Згенерувати зображення',
      ENTER_PROMPT: 'Опишіть зображення для генерації',
      AGE_ERROR: 'Запит відхилено: вимоги безпеки. Персонажі молодше 18 років заборонені.',
      PROMPT_PLACEHOLDER: 'Вкажіть модель генерації та опишіть зображення',
      SAFE_GENERATION: 'Безпечна генерація',
      SAFE_GENERATION_PROFILE_REQUIRED_ERROR:
        'Вимкнення безпечної генерації доступне лише за умови ввімкненої в налаштуваннях профілю опції «Показувати NSFW контент».',
    },
    CHATBOT_REMOVED: {
      TITLE: 'Чат-бот видалений',
      TEXT: 'Цей чат-бот був видалений автором або адміністратором. Почніть спілкуватися з іншими ботами вже зараз.',
      GO_HOME: 'На головну',
    },
    EMAIL_CONFIRMED: {
      TITLE: 'Вашу електронну пошту підтверджено',
      TEXT: 'Ваш обліковий запис повністю активовано й готовий до роботи. Почніть просто зараз: оберіть одного з наших популярних чат-ботів або створіть власного.',
      BUTTON: 'Чудово!',
    },
    AUTH_SESSION_ERROR: {
      TITLE: 'Щось пішло не так',
      TEXT: 'Не вдалося підтвердити вашу авторизацію. Схоже, виникли тимчасові труднощі зі звʼязком або на нашому боці. Будь ласка, оновіть сторінку або спробуйте пізніше.',
      RETRY_BUTTON: 'Спробувати знову',
      RETURN_TO_SIGN_IN_BUTTON: 'Повернутися до входу',
    },
    WELCOME: {
      AGE_AGREE: 'Я підтверджую, що мені 18 років або більше',
      BOUND_BY: 'Ви погоджуєтеся дотримуватися наших',
    },
    GUIDELINES: {
      TITLE: 'Угода про правила спільноти',
      TEXT_1:
        'Щоб забезпечити позитивний і поважний досвід для всіх, ми просимо вас дотримуватися наших правил спільноти, які включають наступне:',
      TEXT_2:
        'Заборонено будь-який контент, пов’язаний із незаконними темами, такими як інцест, неповнолітні або будь-яка незаконна діяльність.',
      TEXT_3: 'Поважайте інших і підтримуйте безпечний простір для різноманітних обговорень.',
      TEXT_4: 'Дотримуйтесь усіх застосовних законів і враховуйте стандарти спільноти.',
      TEXT_5:
        'Продовжуючи, ви погоджуєтеся дотримуватися цих правил і допомагати підтримувати здорове та поважне середовище. Давайте робити спілкування веселим та ввічливим для всіх!',
      I_HAVE: 'Я прочитав і буду дотримуватися',
      START_CHATTING: 'Почати чат',
    },
    ALLOW_NSFW_CONTENT: {
      TITLE: 'Доступ до NSFW-контенту',
      TEXT: 'Видимість контенту має бути увімкнена в налаштуваннях вашого облікового запису. Після увімкнення ви зможете керувати відображенням NSFW-контенту безпосередньо з головної сторінки.',
      GO_TO_SETTINGS: 'Перейти до налаштувань',
    },
    CHAT_DECRYPT: {
      TITLE: 'Цей чат захищено паролем',
      TEXT: 'Введіть пароль для доступу до чату',
      ENCRYPT_PASSWORD: 'Пароль шифрування',
      CONFIRM_ENCRYPT_PASSWORD: 'Підтвердіть пароль шифрування',
    },
    CHAT_ENCRYPT: {
      TITLE: 'Сквозне шифрування',
      NOT_ENCRYPTED: 'Ваш чат не зашифрований',
      ENCRYPTED: 'Ваш чат зашифрований',
      TEXT: 'Повідомлення та чати захищені сквозним шифруванням. Треті сторони, включно з {{brand}}, не можуть читати ваші повідомлення.',
      ENTER_LABEL: 'Створіть пароль шифрування, якщо хочете увімкнути шифрування для чату з чат-ботом.',
      ENABLE: 'Увімкнути шифрування',
      DISABLE: 'Вимкнути шифрування',
    },
    CHARACTER_INFO: {
      CHOOSE_A_PERSONA: 'Виберіть персонажа:',
      AI_MODEL_AND_A_SYSTEM_PROMPT: 'AI-модель і системна підказка',
      TAGS: 'Теги',
      TAGS_PLACEHOLDER: 'Додайте теги з ключовими словами для персонажа (максимум 10 тегів)',
      START_CHAT: 'Почати чат',
    },
    IMAGES_GENERATION_SETTINGS: {
      IMAGES_TITLE: 'Зображення',
      NEGATIVE_PROMPT: 'Негативний промт',
      NEGATIVE_PROMPT_PLACEHOLDER: 'Напишіть, що ви не хочете бачити на зображеннях',
      STYLE_TITLE: 'Стиль',
      STYLE_ANIME: 'Аніме',
      UNI_STYLE: 'Універсальний стиль',
      STYLE_REALISTIC: 'Реалістичний',
      GENERATION_OF_NSFW: 'Генерація NSFW-зображень',
      GENERATION_OF_NSFW_TOOLTIP: 'Увімкніть, якщо хочете бачити контент, не призначений для неповнолітніх.',
      NSFW_PROFILE_REQUIRED_ERROR: 'Генерація NSFW доступна лише тоді, коли в профілі увімкнено налаштування «Показувати NSFW контент».',
      GUIDANCE_SCORE: 'Коефіцієнт спрямованості',
      CREATIVE: 'Креативний',
      PRECISE: 'Точний',
      DISABLE: 'Вимкнути',
      ENABLE: 'Увімкнути',
    },
    PROFILE_SETTINGS: {
      MY_ACCOUNT: {
        MY_ACCOUNT: 'Мій акаунт',
        CHANGE_PERSONA: 'Змінити персонажа',
        DEFAULT_PERSONA: 'Персонаж за замовчуванням',
        USERNAME: {
          USERNAME: 'Ім’я користувача',
          PLACEHOLDER: 'Введіть ім’я користувача',
          ERROR: 'Імʼя користувача може містити лише латинські літери (a–z), цифри та дефіси',
          ERROR_LENGTH: 'Ім’я користувача має бути від 3 до 20 символів.',
        },
        EMAIL: {
          EMAIL: 'Електронна пошта',
          PLACEHOLDER: 'Введіть вашу електронну пошту',
          VERIFIED: 'Пошту підтверджено',
          VERIFY: 'Підтвердити пошту',
          NOT_VERIFIED: 'Пошту не підтверджено',
        },
        EMAIL_VERIFICATION: {
          TITLE: 'Підтвердження пошти',
          TEXT_1: 'На адресу було надіслано лист',
          TEXT_2: 'Будь ласка, натисніть на посилання у цьому листі, щоб завершити підтвердження.',
          NO_CODE: 'Не отримали код?',
          RESEND: 'Надіслати ще раз',
          SEC: 'сек',
          ERROR: 'Не вдалося надіслати лист для підтвердження. {{error}}',
          VALIDATION_ERROR: 'Сталася помилка валідації. Спробуйте ще раз',
          RECEIVE_LINK: 'На вказану електронну пошту буде надіслано посилання для підтвердження.',
        },
        DATE_OF_BIRTH: 'Дата народження',
        DATE_OF_BIRTH_ERROR: 'Мінімальний вік має бути щонайменше 18 років',
        FILL_OUT_WARNING: 'Необхідно заповнити',
        DESCRIPTION: 'Опис',
        DESCRIPTION_PLACEHOLDER: 'Введіть короткий опис тут',
        SOCIALS: 'Соцмережі',
        ADD_NEW: 'Додати нову',
        SAVE: 'Зберегти',
        SUCCESS: 'Дані успішно збережені!',
        FAIL: `Не вдалося зберегти дані, {{error}}`,
      },
      PASSWORD_RESET: {
        ENTER_NEW_PASSWORD: 'Введіть новий пароль у поля нижче.',
        INVALID_URL: 'Недійсне посилання. Будь ласка, запитайте скидання пароля знову.',
        APPLY_NEW_PASSWORD: 'Застосувати новий пароль',
        REQUEST_PASSWORD_RESET: 'Запитати скидання пароля',
      },
      PREFERENCES: {
        PREFERENCES: 'Налаштування',
        THEME: {
          THEME: 'Тема',
          SYSTEM: 'Системна',
          LIGHT: 'Світла',
          DARK: 'Темна',
        },
        NSFW: {
          TITLE: 'Відображати чат-боти з відвертими зображеннями або мовою (NSFW)',
          ERROR: 'Ви не можете ввімкнути відображення контенту NSFW. Будь ласка, підтвердіть, що вам виповнилося 18 років на ',
          ERROR_EMAIL: 'Підтвердіть електронну пошту, щоб вимкнути безпечний пошук і відкрити більше можливостей.',
          LINK: 'вкладці «Мій обліковий запис»',
          SUCCESS: 'Вашу електронну пошту успішно підтверджено. NSFW-контент тепер доступний для вас',
        },
        NOTIFICATIONS: {
          SUCCESS: 'Налаштування успішно застосовано!',
          FAIL: 'Не вдалося застосувати налаштування',
        },
      },
      SECURITY: {
        SECURITY: 'Безпека',
        TWO_FACTOR: {
          TITLE: 'Двофакторна автентифікація',
          DESCRIPTION: 'Двофакторна автентифікація (2FA) забезпечує надійніший захист облікового запису.',
          DOWNLOAD: 'Завантажити Google Authenticator',
          APP_DESCRIPTION:
            'Google Authenticator – це незалежна служба від Google Inc., яка допомагає захистити ваш обліковий запис. Після налаштування вам потрібно буде підтвердити вхід у програму або виведення коштів за допомогою пароля, згенерованого Google Authenticator.',
          SCAN: 'Відскануйте QR-код або завантажте з магазину додатків',
          DOWNLOAD_ON_THE: 'Завантажити на',
          WORKS_WITH: 'Працює з',
          STEP: {
            STEP: 'Крок',
            ONE: 'Введіть пароль',
            TWO: 'Завантажте застосунок',
            THREE: 'Додайте ключ',
            FOUR: 'Введіть код',
            FIVE: 'Завантажте коди',
          },
          CONTINUE: 'Далі',
          CONFIRM: 'Підтвердити',
          ADD_KEY: 'Додайте ключ до Google Authenticator та створіть резервну копію',
          ADD_KEY_TIP: 'Відкрийте Google Authenticator, проскануйте QR-код або введіть ключ нижче, щоб додати токен підтвердження.',
          SCAN_QR_CODE: 'Відскануйте QR-код або введіть ключ нижче в додаток',
          CODE_TIP: 'Збережіть свій ключ на випадок виникнення проблем зі входом, таких як втрата телефону чи інші проблеми.',
          COPY: 'Копіювати',
          COPIED: 'Скопійовано',
          ENTER: 'Введіть код із програми Google Authenticator.',
          ENTER_TIP: 'Відкрийте застосунок GA та введіть код підтвердження в поле нижче.',
          GA_CODE: 'Код GA',
          ENTER_CODE: 'Введіть код',
          DOWNLOAD_CODES: {
            TITLE: 'Завантажити резервні коди',
            TIP: 'Збережіть ці резервні коди в безпечному місці. Ви зможете використати їх для доступу до свого облікового запису, якщо втратите пристрій автентифікації.',
            WARNING: 'Кожен код можна використати лише один раз. Зберігайте їх безпечно.!',
            BUTTON: 'Завантажити резервні коди',
          },
          DISABLE: {
            TITLE: 'Вимкнути двофакторну автентифікацію',
            TIP: 'Введіть свій пароль, щоб вимкнути двофакторну аутентифікацію. Це зробить ваш обліковий запис менш захищеним..',
            WARNING: 'Вимкнення 2FA видалить важливий рівень безпеки з вашого облікового запису',
            BUTTON: 'Вимкнути 2FA',
          },
          ENABLE_SUCCESS: 'Двофакторну автентифікацію успішно ввімкнено',
          ENABLE_FAIL: 'Не вдалося ввімкнути двофакторну автентифікацію',
          DISABLE_SUCCESS: 'Двофакторну автентифікацію успішно вимкнено',
          DISABLE_FAIL: 'Не вдалося вимкнути двофакторну автентифікацію',
          ENTER_CODE_FROM_DEVICE: 'Для вашої безпеки введіть 6-значний код, згенерований у додатку на вашому пристрої.',
          VERIFICATION_CODE: 'Код підтвердження',
          TRUST_DEVICE: 'Довіряти цьому пристрою протягом 30 днів',
          AUTH_APP: 'Додаток',
          BACKUP_CODE: 'Резервний код',
          DISCLAIMER_1: 'Це допомагає захистити ваш обліковий запис.',
          DISCLAIMER_2: 'Ніколи не діліться своїм OTP з ким-небудь.',
          ENTER_BACKUP_CODE: 'Введіть резервний код',
          BACKUP_TIP: 'Використайте резервний код, якщо немає доступу до застосунку',
          INVALID_CODE: 'Введений код недійсний. Спробуйте інший',
        },
        PASSWORD: {
          TITLE: 'Пароль',
          AGO: 'Змінено',
          CURRENT: 'Поточний пароль',
          NEW: 'Новий пароль',
          CONFIRM: 'Підтвердіть новий пароль',
          SIGN_OUT: 'Вийти з усіх активних сесій',
          SET: 'Встановити пароль',
          CHANGE: 'Змінити пароль',
          SUCCESS: 'Пароль успішно змінено!',
          FAIL: 'Не вдалося змінити пароль, {{error}}',
          PLACEHOLDER: 'Введіть пароль',
          TIP: 'У вас ще не встановлено пароль для входу на сайт. Щоб налаштувати двофакторну автентифікацію, потрібно створити пароль для вашого облікового запису.',
          CREATE: 'Створити пароль',
        },
        SOCIAL: {
          TITLE: 'Вхід через соціальні мережі',
          DESCRIPTION:
            'Підключіть свій обліковий запис {{brand}} до облікових записів соціальних мереж для простого та безпечного входу. Вхід через соціальні мережі пропускає двоетапну перевірку та може знизити безпеку вашого облікового запису.',
          CONNECT: 'Підключити',
          DISCONNECT: 'Відключити',
          CONNECTED: 'Підключено',
          NOT_CONNECTED: 'Не підключено',
          NOTIFICATIONS: {
            SUCCESS: 'Обліковий запис {{providerName}} успішно відключено',
            FAIL: 'Не вдалося відключити обліковий запис, {{error}}',
          },
        },
      },
    },
    PAYMENTS: {
      TOKENS_TITLE: 'Ви купуєте токени',
      SUBSCRIPTION_TITLE: 'Ви купуєте підписку',
      RENEWAL: 'Продовження відбудеться через {{period}} днів за ${{price}}/{{period}} днів. Скасувати можна будь-коли.',
      SECURE: 'Платежі захищені та зашифровані',
      CHANGE: 'Змінити',
      SUBTOTAL: 'Проміжний підсумок',
      DISCOUNT: 'Знижка',
      TOTAL: 'Разом',
      CONTACT_INFORMATION: 'Контактна інформація',
      CHOOSE_SUBSCRIPTION_PERIOD: 'Оберіть період підписки',
      CHOOSE_PAYMENT_METHOD: 'Оберіть спосіб оплати',
      TOS_1: 'Натискаючи кнопку «Продовжити», ви підтверджуєте, що вам 18 років або більше та приймаєте',
      TOS_2: 'та',
      TOS_3: '. Ми дбаємо про вашу конфіденційність, тому платіж у виписці по карті буде відображатися як "{{ brand }}".',
      TOS_4: 'З будь-яких питань щодо платежів, будь ласка, зверніться до служби підтримки за адресою {{ email }}.',
      TOS_5: 'Ви погоджуєтеся, що ми збережемо вашу платіжну інформацію, щоб вам не потрібно було вводити її знову в майбутньому.',
      BONUS: 'Бонус',
    },
    DELETE_CHAT: {
      TITLE: 'Видалити чат',
      TEXT: 'Ви впевнені, що хочете видалити цей чат? Після видалення його неможливо буде відновити.',
      SUCCESS: 'Чат успішно видалено!',
      FAIL: 'Не вдалося видалити чат!',
    },
    DELETE_PERSONA: {
      TITLE: 'Видалити персонажа',
      TEXT:
        'Видалення цього персонажа призведе до незворотних наслідків — відновити його буде неможливо.\n' +
        'Історія спілкування з ботами залишиться, і ви зможете продовжити розмову, але від імені іншого персонажа.\n' +
        '\n',
      SURE: 'Ви впевнені, що хочете видалити цей профіль?',
      WARNING: 'Поточний персонаж за замовчуванням не можна видалити.\n' + 'Спочатку виберіть іншого за замовчуванням або створіть нового.',
      SUCCESS: 'Персонажа успішно видалено!',
      FAIL: 'Не вдалося видалити персонажа!',
    },
    DELETE_CHATBOT: {
      TITLE: 'Видалити чат-бота',
      TEXT_1: 'Видалення чат-бота також призведе до видалення всіх чатів та зображень у них. Їх неможливо буде відновити.',
      TEXT_2: 'Ви впевнені, що хочете видалити цього чат-бота?',
      SUCCESS: 'Чат-бот успішно видалений!',
      FAIL: 'Не вдалося видалити чат-бота!',
    },
    BLOCK_CREATOR: {
      TITLE: 'Заблокувати цього автора?',
      TEXT: 'Ви впевнені, що хочете заблокувати всіх чат-ботів цього автора? Ви можете розблокувати їх у будь-який час.',
      BLOCK: 'Заблокувати',
    },
    UNBLOCK_CREATOR: {
      TEXT: 'Ви впевнені, що хочете розблокувати автора ',
      CANCEL: 'Ні',
      SUCCESS: 'Автора успішно розблоковано!',
      FAIL: 'Не вдалося розблокувати автора. Будь ласка, спробуйте пізніше.',
    },
    COMPLAIN: {
      TITLE: 'Скарга',
      DETAILS_PLACEHOLDER: 'Опишіть, що вас не влаштувало',
      MAX_CHECKBOXES: 'Ви можете вибрати максимум 5 чекбоксів',
      CHECKBOX: {
        THREATS: 'Погрози та домагання',
        CRUELTY: 'Надмірна жорстокість',
        FALSE: 'Хибні твердження',
        HATRED: 'Розпалювання ненависті',
        NSFW: 'Непридатне для роботи (NSFW)',
        HARASSMENT: 'Сексуальні домагання',
        CHILD_EXPLOIT: 'Експлуатація дітей',
        SELF_HARM: 'Самопошкодження',
        TERRORISM: 'Тероризм і екстремізм',
        ILLEGAL: 'Незаконна діяльність',
        DRUGS: 'Наркоторгівля',
        CONFIDENTIALITY: 'Порушення конфіденційності',
        IMPERSONATION: 'Самозванство',
        SPAM: 'Комерційний спам',
      },
    },
    TELL_US_MORE: {
      TITLE: 'Розкажіть більше',
      ADDITIONAL_DETAILS: 'Додаткові деталі',
      DETAILS_PLACEHOLDER: 'Опишіть, що вас порадувало',
      SUCCESS: 'Ваш відгук успішно надіслано!',
      FAIL: 'Не вдалося надіслати відгук. Будь ласка, спробуйте пізніше.',
      FUNNY: 'Смішно',
      HEALTHY: 'Корисно',
      FLIRTY: 'Фліртливо',
      INTERESTING: 'Цікаво',
      GOOD_MEMORY: 'Хороша пам’ять',
    },
    MODEL_CARD_CREATOR: {
      SET_FAVORITE: {
        SUCCESS: 'Модель успішно додана в обране',
        FAIL: 'Не вдалося додати в обране, спробуйте пізніше.',
      },
      UNSET_FAVORITE: {
        SUCCESS: 'Модель успішно видалена з обраного',
        FAIL: 'Не вдалося видалити з обраного, спробуйте пізніше.',
      },
    },
    PROMPTS_CARD_CREATOR: {
      SET_FAVORITE: {
        SUCCESS: 'Стиль оповіді успішно додано до обраного',
        FAIL: 'Не вдалося додати в обране, спробуйте пізніше.',
      },
      UNSET_FAVORITE: {
        SUCCESS: 'Стиль оповіді успішно видалено з обраного',
        FAIL: 'Не вдалося видалити з обраного, спробуйте пізніше.',
      },
    },
    MEMORIES: {
      TITLE: 'Спогади',
      PLACEHOLDER_1: 'Тут ще немає спогадів.',
      PLACEHOLDER_2: 'Продовжуйте чат з ботом або створіть нового.',
      INPUT_PLACEHOLDER: 'Додати новий спогад...',
      SUBTITLE: 'Додайте спогади про ваші попередні взаємодії з персонажем',
      EDIT: 'Редагувати спогад',
      DELETE: 'Видалити спогад',
      PIN: 'Закріпити спогад',
      UNPIN: 'Відкріпити спогад',
      PINNED: '(Закріплено)',
      EDITED: '(змінено)',
      DELETE_TEXT: 'Ви впевнені, що хочете видалити цей спогад? Після видалення його неможливо буде відновити.',
      MEMORIES_ENABLED: 'Спогади успішно увімкнено!',
      MEMORIES_DISABLED: 'Спогади успішно вимкнено!',
      FAILED_TO_UPDATE: 'Не вдалося оновити налаштування спогадів!',
    },
    REGISTRATION: {
      TITLE: 'Створіть обліковий запис',
      LOGIN_WITH_EMAIL: 'Увійти за допомогою email',
      CONTINUE: 'Продовжити',
      HAVE_AN_ACCOUNT: 'Вже маєте акаунт?',
      DONT_HAVE_AN_ACCOUNT: 'Немає акаунта?',
      YOU_AGREE: 'Реєструючись, ви погоджуєтесь з нашими',
      TERMS_AND_CONDITIONS: 'Умовами та положеннями',
      YOU_HAVE_READ: 'і ви ознайомилися з нашою',
      PRIVACY_POLICY: 'Політикою конфіденційності',
      FORGOT_PASSWORD: 'Забули пароль?',
      CONTINUE_WITH: 'або продовжити через',
      SEND_MAGIC_LINK: 'Надіслати Magic Link на електронну пошту',
    },
    MAGIC_LINK: {
      TITLE: 'Увійти за допомогою Magic Link',
      TEXT: 'Введіть свою електронну пошту, і ми надішлемо вам Magic Link для миттєвого входу',
      SEND: 'Надіслати Magic Link',
      SUCCESS: 'Перевірте свою пошту — ми надіслали вам Magic Link для миттєвого входу!',
    },
    PASSWORD_RECOVERY: {
      TITLE: 'Відновити пароль',
      RECOVERY_LINK:
        'Посилання для відновлення пароля було надіслано на вашу пошту. Будь ласка, перевірте скриньку та перейдіть за посиланням, щоб скинути пароль.',
      ENTER_EMAIL: 'Введіть адресу електронної пошти, яку ви використовували при реєстрації, і ми надішлемо вам інструкції',
      RESET_PASSWORD: 'Скинути пароль',
    },
    NONEXISTING: {
      TITLE: 'Ой...',
      TEXT: 'Те, що ви шукаєте, може бути в іншому місці або просто не існує. Будь ласка, спробуйте ще раз.',
    },
    CHOOSE_PERSONA: {
      TITLE: 'Вибрати персонажа',
      SUBTITLE: 'Зміна персонажа під час розмови може порушити сюжетну послідовність.',
      SUCCESS: 'Персонажа успішно змінено!',
      FAIL: 'Не вдалося змінити персонажа!',
    },
    IMPORT_CHATBOT: {
      TITLE: 'Імпорт чат-бота',
      DESCRIPTION: 'Наразі ми підтримуємо імпорт персонажів із spicychat.ai та juicychat.ai.',
      IMPORT_FROM_FILE: {
        TITLE: 'Імпорт за допомогою JSON або зображення картки',
        DESCRIPTION: 'Завантажте JSON-файл символів або зображення із вбудованими даними символів.',
        SUPPORTED_LABEL: 'Підтримувані формати:',
        SUPPORTED_FORMATS: 'JSON, PNG, JPG',
        CLICK: 'Натисніть, щоб вибрати або перетягніть файл сюди',
      },
      IMPORT_FROM_URL: {
        TITLE: 'Імпорт за URL-адресою',
        ENTER: 'Введіть URL-адресу з підтримуваних веб-сайтів',
        CHATBOT_URL: 'URL-адреса чат-бота',
        IMPORT_FROM_URL: 'Імпорт з URL-адреси',
      },
    },
    BOOSTY_PAYMENT_STATUS: {
      LINK_ACCOUNT: "Прив'яжіть свій акаунт Boosty",
      ENTER_EMAIL_DESCRIPTION: "Для оплати підписки Boosty, будь ласка, введіть Email, прив'язаний до вашого акаунту Boosty нижче",
      EMAIL_WARNING: "Увага! Email прив'язується до вашого акаунту CAICHAT.AI і не може бути змінений",
      EMAIL_LABEL: "Email, прив'язаний до Boosty",
      EMAIL_PLACEHOLDER: 'Введіть ваш Email',
      WHERE_FIND_EMAIL: 'Де знайти інформацію про мій email на Boosty?',
      INSTRUCTION_STEP_1: 'Натисніть на свій аватар і виберіть "Налаштування акаунту" з випадаючого меню',
      INSTRUCTION_STEP_2: 'На вкладці "Профіль" ви знайдете свій Email. Просто скопіюйте його і вставте в форму на цій сторінці',
      HAVE_YOU_PAID: 'Ви оплатили підписку?',
      CONFIRM_PAYMENT_DESCRIPTION:
        'Якщо ви оплатили підписку Boosty, будь ласка, підтвердіть це нижче. Ми синхронізуємо дані для перевірки.',
      SYNC_FAILED: 'Синхронізація не вдалася. Будь ласка, перевірте правильність вашого email та успішність оплати підписки Boosty.',
      CONTACT_SUPPORT: "Якщо у вас є питання або потрібно змінити вказаний Email, будь ласка, зв'яжіться з підтримкою.",
      RETURN_TO_BOOSTY: 'Повернутися до оплати на Boosty',
      GO_TO_BOOSTY: 'Оплатити на Boosty',
      I_HAVE_PAID: 'Я оплатив',
      SUCCESS_PAYMENT: 'Ви успішно оплатили підписку Boosty!',
      CONGRATULATIONS: 'Вітаємо! Тепер ви можете використовувати більше функцій на CAICHAT.AI. Починайте нові чати прямо зараз!',
      DATA_SYNCHRONIZED: 'Дані синхронізовані',
      SUBSCRIPTION_VALID_UNTIL: 'Підписка дійсна до',
      MY_PREVIOUS_CHATS: 'Мої попередні чати',
      GO_TO_HOMEPAGE: 'Перейти на головну',
      SYNCHRONIZING_DATA: 'Синхронізація даних',
    },
    TOP_UP: {
      TITLE: 'Поповніть баланс токенів',
      NOT_ENOUGH: 'У вас недостатньо',
      TOKENS: 'токенів для створення зображень.',
      TOP_UP_AND: 'Поповніть баланс і',
      GENERATE_AMAZING_PHOTOS: 'створюйте вражаючі фото',
      RIGHT_IN_THE_CONVERSATION: 'просто в розмові!',
      BUY_TOKENS: 'Купити токени',
    },
    PAYMENT_RESULT: {
      PAYMENT_ORDER_DETAILS: 'Деталі платіжного замовлення',
      ORDER_ID: 'ID замовлення',
      STATUS: 'Статус',
      AMOUNT: 'Сума',
      PURCHASED: 'Придбано',
      PAYMENT_METHOD: 'Метод оплати',
      PROVIDER_ORDER_ID: 'ID замовлення провайдера',
      CREATED_AT: 'Створено',
      COMPLETED_AT: 'Завершено',
      STATUSES: {
        COMPLETED: 'Завершено',
        FAILED: 'Помилка',
        PENDING: 'В очікуванні',
        PROCESSING: 'Обробка',
        CANCELLED: 'Скасовано',
        REFUNDED: 'Повернено',
      },
    },
    CREATE_REFERRAL_CAMPAIGN: {
      CREATE: 'Створити кампанію',
      EDIT: 'Редагувати кампанію',
      NAME: 'Назва кампанії',
      NAME_PLACEHOLDER: 'Введіть текст',
      NAME_DESCRIPTION:
        'Назва кампанії буде відображатися лише для вас і використовується виключно для зручності пошуку. Інші користувачі її не побачать.',
      CODE_DESCRIPTION: 'Реферальний код буде згенеровано автоматично під час створення кампанії.',
    },
    DELETE_REFERRAL_CAMPAIGN: {
      DELETE: 'Видалити цю кампанію?',
      TEXT: 'Після видалення інші користувачі не зможуть використовувати промокод цієї кампанії. Відновлення даних буде неможливим. Ви впевнені, що хочете видалити?',
    },
  },
  BLOCKS: {
    BANNER_MAIN: {
      SLIDE_1: {
        TITLE: 'РОЗШИРЮЙ МЕЖІ ІСТОРІЇ',
        TEXT: 'Персонажі, які памʼятають усе — тобі не доведеться повторюватися.',
        BUTTON: 'Прокачати памʼять',
      },
      SLIDE_2: {
        TITLE: 'Твоя історія оживає',
        TEXT: 'Преміум-моделі, необмежена генерація зображень і голос для твого компаньйона!',
        BUTTON: 'Отримати все',
      },
      SLIDE_3: {
        TITLE: 'Новий рівень спілкування',
        TEXT: 'Глибші відповіді, насичені сцени. Персонажі, які проживають історію разом з тобою.',
        BUTTON: 'Максимум можливостей',
      },
      SLIDE_NOT_AUTH: {
        TITLE: 'Безмежне спілкування з ШІ',
        TEXT: 'Тисячі унікальних персонажів! Реєструйся та занурюйся в нескінченні історії!',
        BUTTON: 'Почати безкоштовно',
      },
      SOCIALS_SLIDE: {
        TITLE: 'Приєднуйтесь до нашої спільноти',
        TITLE_MOBILE: 'Приєднуйтесь!',
        TEXT: 'Дізнавайтеся першими про новини та круті функції в наших соціальних мережах.',
        JOIN_OUR: 'Приєднуйтесь до Discord',
        FOLLOW_US_ON: 'Знайдіть нас у {{target}}',
        DISCORD: 'Discord',
        TIKTOK: 'TikTok',
        INSTAGRAM: 'Instagram',
      },
      SLIDE_GIVEAWAY: {
        TITLE: 'Щотижневі розіграші 30k токенів',
        DESCRIPTION: 'Приєднуйтесь до нашого Discord-каналу та беріть участь у розіграші токенів',
      },
      MORE_TOKENS: {
        TITLE: 'Більше токенів для вас',
        DESCRIPTION: 'Приєднуйтесь до Discord і отримуйте безкоштовні токени щотижня',
      },
    },
    SORT: {
      MOST_CHATS: 'Найбільше чатів',
      NEWEST: 'Найновіші',
      OLDEST: 'Найстаріші',
      MOST_POPULAR: 'Найпопулярніші',
      MOST_LIKED: 'Уподобані',
      ALL_MODELS: 'Моделі',
      FREE: 'Безкоштовні',
      RECOMMENDED: 'Рекоменд.',
      TOKENS: 'Токени',
      MY_PLAN: 'Тариф',
      TRENDING: 'У тренді',
      A_Z: 'A–Я',
      Z_A: 'Я–A',
      PRICE_ASC: 'Спочатку дешеві',
      PRICE_DESC: 'Спочатку дорогі',
    },
    SORT_MODAL: {
      TITLE: 'Оберіть сортування',
    },
    LEFT_SIDEBAR: {
      HOME: 'Головна',
      SMART_SEARCH: 'Розумний пошук',
      CATALOG: 'Каталог',
      CHATS: 'Чати',
      MY_PERSONAS: 'Мої персонажі',
      CREATE_CHATBOT: 'Створити чат-бота',
      MY_CHATBOTS: 'Мої чат-боти',
      MY_GAMES: 'Мої ігри',
      FAVORITES: 'Вибране',
      BLOCKED_CREATORS: 'Заблоковані автори',
      SUBSCRIBE: 'Підписка',
      NOTIFICATIONS: 'Сповіщення',
      HELP: 'Допомога',
      UPGRADE: 'Оновити',
    },
    RIGHT_SIDEBAR: {
      UPGRADE_PLAN: 'Оновити план',
      GET_PLAN: 'Оновити підписку',
      FREE: 'Безкоштовний',
      ACTIVE: 'Активний',
      DREAMER: 'Мрійник',
      EXPLORER: 'Дослідник',
      STORY_GOD: 'Бог історій',
      NEW_CHAT: 'Новий чат',
      EXTENSIONS: 'Розширення',
      CREATE_PRESET: 'Створити пресет',
      PERSONAS: 'Персони',
      VOICES: 'Голоси',
      BACKGROUNDS: 'Фони',
      RECENT: 'Нещодавно використані моделі штучного інтелекту',
      PROMPT: 'Поведінка',
      NO_MODEL_SELECTED: 'Не вибрано модель для продовження чату',
      SELECT_MODEL_PROMPT: 'Виберіть модель та поведінку',
      SELECT_MODEL: 'Вибрати ІІ-модель',
      BOT_REMOVED: 'Цей чат-бот був видалений автором або адміністрацією. Почніть спілкуватися з іншими ботами вже зараз.',
      CREATE_NEW_CHATBOT: 'Створити чат-бота',
      OPEN_HOMEPAGE: 'На головну',
    },
    CATALOG_FILTER_PANEL: {
      RESET_FILTER: 'Скинути фільтр',
      SEARCH_TAGS: 'Пошук тегів',
      SHOW: 'Показати',
      CHATBOTS: 'чат-ботів',
      NO_TAGS: 'У чат-ботів цього автора поки що немає тегів',
    },
    SAFE_SEARCH_TOGGLE: {
      SAFE_SEARCH: 'Безпечний пошук',
    },
    CHATBOT_INFO: {
      TYPE_GREETING_NAME: 'Введіть привітання',
      ADD_NEW_GREETING: 'Додати нове привітання',
      GREETINGS: 'Перше повідомлення',
      PERSONALITY: 'Особистість',
      SCENARIO: 'Сценарій',
      DIALOG: 'Діалог',
      NOTES: 'Нотатка автора',
      DESCRIPTION: 'Опис',
      AVATAR: 'Аватар',
      NAME: 'Ім’я',
      MARKDOWN_FONT_SIZE: {
        NORMAL: 'Звичайний текст',
        H1: 'Заголовок 1',
        H2: 'Заголовок 2',
        H3: 'Заголовок 3',
        QUOTE: 'Цитата',
      },
      GREETINGS_PLACEHOLDER:
        'Наприклад: Відома археолог з таємничим минулим, Елара Найтшейд провела десятиліття, досліджуючи забуті храми та давні руїни по всьому світу. З її характерними сріблястими пасмами та проникливими янтарними очима вона здобула повагу в академічних колах, зберігаючи ауру загадковості.',
      PERSONALITY_PLACEHOLDER:
        'Опишіть особистість персонажа, риси характеру, минуле, стиль мови тощо. Використовуйте чітку та лаконічну мову. Приклади: «гострий та саркастичний», «завжди говорить римами», «боїться павуків», «колишній детектив, якого переслідує минула справа».',
      SCENARIO_PLACEHOLDER: 'Опишіть сценарій для персонажа. Використовуйте чітку та лаконічну мову.',
      DIALOG_PLACEHOLDER:
        "Наведіть приклад діалогу, який показує, як говорить персонаж. Використовуйте формат: 'Користувач: Привіт\nПерсонаж: [відповідь персонажа]'. Додайте кілька реплік, щоб продемонструвати стиль спілкування.",
      NOTES_PLACEHOLDER: 'Напишіть коротке пояснення для користувачів, як найкраще взаємодіяти з цим ботом',
      CHAT_BACKGROUND: 'Фон чату',
      DELETE_CHAT_BACKGROUND: 'Видалити фон чату',
      HIDE_THIS_BLOCK: 'Приховати цей блок',
    },
    TOKENIZATOR: {
      TOKENS: 'токени',
    },
    BLOCK_BUTTON: {
      NO_BLOCKED: 'У вас немає заблокованих авторів',
      SHARE: 'Поділитися',
      DELETE_CHATBOT: 'Видалити чат-бота',
      EDIT: 'Редагувати',
      BLOCK_CREATOR: 'Заблокувати автора',
      UNBLOCK_CREATOR: 'Розблокувати',
      REPORT: 'Скарга на автора',
      REPORT_CHATBOT: 'Скарга на чат-бота',
      VOICE_OVER: 'Озвучення',
      DELETE_IMAGE: 'Видалити зображення',
      REGENERATE_MESSAGE: 'Згенерувати повідомлення знову',
      NEW_CHAT_FROM_HERE: 'Новий чат звідси',
      BLOCK_SUCCESS: 'Користувач успішно заблокований',
      BLOCK_ERROR: 'Не вдалося заблокувати користувача. Спробуйте пізніше.',
      UNBLOCK_SUCCESS: 'Користувач успішно розблокований',
      UNBLOCK_ERROR: 'Не вдалося розблокувати користувача. Спробуйте пізніше.',
      IMAGE_SETTINGS: 'Налаштування зображення',
      RATE_MESSAGE: 'Оцінити повідомлення',
    },
    CHAT_INPUT: {
      ACTION: 'Дія',
      TYPE_YOUR_MESSAGE: 'Введіть повідомлення...',
      WRITE_IN_LANGUAGE: 'Напиши українською',
      DESCRIBE_YOUR_FEELINGS: 'Опиши почуття',
      GET_OUT_OF_THE_LOOP: 'Вийди з повторів',
      EDIT_MESSAGE_PLACEHOLDER: 'Редагувати повідомлення...',
      DELETED_PERSONA_PLACEHOLDER: 'Вашу персону видалено. Виберіть іншу.',
      DELETED_PRESET_PLACEHOLDER: 'Модель недоступна. Будь ласка, виберіть іншу.',
      SUBSCRIBE_PLACEHOLDER: 'Обрана AI-модель недоступна для поточної підписки.',
      SELECT_PERSONA: 'Вибрати персонажа',
      CHANGE_MODEL: 'Змінити модель',
      DELETED_CHAT_TITLE: 'Цей чат-бот був видалений.',
      DELETED_CHAT_TEXT: 'Почніть спілкуватися з іншими ботами вже зараз.',
      GO_HOME: 'На головну сторінку',
      NO_MORE_TOKENS: `<span>У вас немає</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="size-4 inline-block"><path d="M12.4137 5.51725H8.63443L12.1379 0H7.72409L3.58618 8.27588H6.84137L3.58618 16L12.4137 5.51725Z" fill="#ff9f32"/></svg><span>токенів для цієї моделі. Поповніть баланс або перейдіть на іншу модель</span>`,
      LOW_QUALITY_MODEL: 'Модель низької якості',
      AVATAR_CHANGED: 'Аватар було змінено',
    },
    PRICING_CARD_GROUP: {
      WEEKLY: 'Тиждень',
      MONTHLY: '1 місяць',
      // Используется в purchase history таблице
      ONE_MONTH: '1 місяць',
      THREE_MONTHS: '3 місяці',
      YEARLY: 'Рік',
      ONE_YEAR: 'Рік',
      SUBSCRIBE_PLAN: 'Оформити підписку',
      UP_TO: 'До {{percent}}%',
      OFF: 'Знижка {{percent}}%',
      PRICE: 'Вигода {{percent}}%',
    },
    PRICING_CARD: {
      MOST_POPULAR: 'Найпопулярніший',
      MY_SUBSCRIPTION: 'Моя підписка',
      SUBSCRIBE: 'Підписатися',
      UNSUBSCRIBE: 'Відписатися',
      ACTIVE: 'Вищий рівень активний',
      IN_ADDITION: 'Додатково до попередніх рівнів:',
      SEE_ALL_FEATURES: 'Переглянути всі можливості...',
      IN_EXTRA: 'додатково за промокодом',
    },
    MY_PROFILE_CARD: {
      DATE_OF_BIRTH: 'Дата народження:',
      REGISTERED: 'Зареєстровано:',
      SUBSCRIBERS: 'Підписники',
      LIKES: 'Лайки',
      MY_CHATBOTS: 'Мої чат-боти',
      MY_PUBLIC_PAGE: 'Моя публічна сторінка',
      BALANCE: 'Баланс:',
      ADD_TOKENS: 'Додати токени',
    },
    CHAT_HEADER: {
      DISCLAIMER:
        '{{brand}} працює на базі ШІ для творчого сторітелінгу та рольових ігор. Усі розмови вигадані, не сприймайте їх як реальні факти. Використовуйте відповідально!',
      SHOW_PREVIOUS: 'Показати попереднє',
    },
    OVERLAY_INVITE_CODE: {
      TITLE: 'Ваша історія починається тут!',
      SUBTITLE: 'Залишився лише один крок, щоб розблокувати чудові функції',
      ENTER_CODE: 'Введіть код запрошення',
      INVITE_CODE: 'Код запрошення',
      LETS_GO: 'Поїхали!',
      NEED_CODE: 'Потрібен код запрошення?',
      JOIN_DISCORD: 'Приєднайтесь до Discord для доступу',
      SIGN_OUT: 'Вийти',
    },
    TOKEN_PACK_CARD: {
      BUY: 'Купити',
      SALE: 'Знижка',
      BONUS: 'Бонус',
    },
    COMPARE_PLANS_TABLE: {
      MOST_POPULAR: 'Популярно',
      FUNCTION_LIMIT: 'Функція/Ліміт',
      INCLUDED_IN_PLAN: 'Включено в план',
      NOT_INCLUDED_IN_PLAN: 'Не включено в план',
      MAIN_FUNCTION: 'ОСНОВНА ФУНКЦІЯ',
      BONUS_FOR_SUB: 'Бонусні токени за підписку (при поновленні)',
      UNLIMITED_MESSAGES: 'Безлімітні повідомлення',
      COUPON_MONTH: 'Разовий купон при підписці на 30 днів',
      COUPON_YEAR: 'Разовий купон при річній підписці',
      USER_IDENTITIES: 'Персонажі користувача',
      USER_IDENTITIES_TOOLTIP:
        'Після завершення підписки ви перейдете на Free plan і не зможете створювати нових персон, доки не звільните місце.',
      ABILITY_TO_USE: 'Можливість використовувати власні моделі',
      ACCESS_OTHER_EXTENSIONS: 'Доступ до інших та стандартних розширень',
      AVAILABLE_CONTEXT_TOKENS: 'Доступні токени контексту',
      AVAILABLE_LLM_TOKENS: 'Доступні токени відповіді LLM',
      LIMITATION_ON_MODELS: 'ОБМЕЖЕННЯ ПО МОДЕЛЯХ',
      AVAILABLE_CHARACTERS: 'Доступні персонажі',
      NO_RESTRICTIONS:
        'Немає обмежень на використання Контексту, Відповідей LLM, Персонажів і системних підказок при використанні власних моделей, крім зазначених у розділі «Ваші AI моделі»',
      CREATE_EXTENSIONS: 'Створювати власні розширення',
      ADDITIONAL_FEATURES: 'ДОДАТКОВІ ФУНКЦІЇ',
      SYSTEM_PROMPTS: 'Системні підказки',
      IMAGE_GEN: 'Генерація зображень доступна за токени – певна кількість зображень на день безкоштовно',
      AVATAR_GEN_ALL: 'Генерація аватарів для всіх персонажів, включаючи приватних',
      CHAT_ENCRYPTION: 'Шифрування чату',
      ACCESS_EXTENSIONS: 'Доступ до розширень',
      ACCESS_MEMORY_MANAGER: 'Доступ до менеджера пам’яті (Memories) з можливістю додавати власні записи',
      SEMANTIC_MEMORY: 'Семантична пам’ять 2.0',
      TTS: 'Текст-в-Мову (озвучка відповідей)',
      CREATE_PRIVATE_CHARACTERS: 'Створювати приватних персонажів',
      CREATE_PUBLIC_CHARACTERS: 'Створювати публічних персонажів',
      AD_FREE: 'Без реклами',
      NO_QUEUE: 'Без черги',
      ADDITIONAL_TOOLS: 'Додаткові інструменти для створення персонажів та розширень',
      LIMITED_EDITION_MODEL: 'Модель обмеженого випуску',
      UP_TO_200: 'до 200',
      UNLIMITED: 'Безліміт',
      ONLY_YOUR_OWN_AND_FREE: 'Тільки свої та безкоштовні',
      RECOMMENDED_MODELS_WITHOUT_LIMITATIONS: 'Наші рекомендації без обмежень по токенах',
      UP_TO_1_PER_DAY_PLUS_UNLIMITED_FOR_FEE: 'До 1 на день + безліміт за плату',
      ONLY_SPEECH: 'Тільки мова',
      UNLIMITED_LOW_QUALITY: 'Безліміт, низька якість',
      UNLIMITED_MEDIUM_QUALITY: 'Безліміт, середня якість',
      UNLIMITED_HIGH_QUALITY: 'Безліміт, висока якість',
      TEN_PERCENT_DISCOUNT_ONE_WEEK: '10% знижка на тиждень',
      MONTHLY_COUPON_TEN_PERCENT_DISCOUNT: 'Щомісячний купон: 10% знижка на токени на тиждень',
      TWENTY_PERCENT_DISCOUNT_ONE_WEEK: '20% знижка на тиждень',
      MONTHLY_COUPON_TWENTY_PERCENT_DISCOUNT: 'Щомісячний купон: 20% знижка на токени на тиждень',
      THE_ENTIRE_ANSWER: 'Повна відповідь',
      THIRTY_PERCENT_DISCOUNT_ONE_WEEK: '30% знижка на тиждень',
      MONTHLY_COUPON_THIRTY_PERCENT_DISCOUNT: 'Щомісячний купон: 30% знижка на токени на тиждень',
      AVAILABLE_CHARACTERS_TOOLTIP:
        'Персонажі, на яких витрачено більше 2000 токенів на особистість і більше 3000 токенів на привітання (береться більше значення), не можуть використовувати безкоштовні моделі.',
      UP_TO_5k_TOKENS: 'До 5000 токенів, витрачених на особистість',
      UP_TO_5k_TOKENS_ACTIVE: 'До 5000 токенів на особистість + моделі рівня Active',
      UP_TO_5k_TOKENS_DREAMER: 'До 5000 токенів на особистість + моделі рівня Dreamer',
      UP_TO_5k_TOKENS_CREATOR: 'До 5000 токенів на особистість + моделі рівня Creator',
      UP_TO_5k_TOKENS_STORY_GOD: 'До 5000 токенів на особистість + моделі рівня Story GOD',
      ACTIVE: 'Активний',
      FREE_PLAN: 'Безкоштовний',
      FREE_MODELS: 'Безкоштовні моделі',
      FREE_MODELS_FREE: 'Безкоштовні моделі для персонажів з особистістю до 5000 токенів',
      FREE_MODELS_ACTIVE: 'Моделі безкоштовного плану + моделі рівня Активний',
      FREE_MODELS_DREAMER: 'Моделі безкоштовного плану + моделі рівня Мрійник',
      FREE_MODELS_CREATOR: 'Моделі безкоштовного плану + моделі рівня Творець',
      FREE_MODELS_STORY_GOD: 'Моделі безкоштовного плану + моделі рівня Бог історій',
    },
    MODEL_PROMPT_PRESET: {
      MODEL: 'Модель',
      DEFAULT: 'За замовчуванням',
      RECOMMENDED: 'Рекомендовано',
      PRESET: 'Пресет',
      LAST_USED: 'Нещодавно',
      SUCCESS: 'Налаштування успішно застосовані!',
      ERROR: 'Не вдалося застосувати налаштування!',
      INCOMPATIBLE: 'Несумісно з моделлю ШІ',
      WE_RECOMMEND: 'Ми рекомендуємо',
      AUTHORS_CHOICE: 'Вибір автора',
      POPULAR: 'Популярне',
      UNSUITABLE_SUBSCRIPTION: 'Ваш тарифний план не підходить для цієї моделі.',
    },
    PUBLIC_PROFILE_HEADER: {
      COPIED: 'скопійовано',
      SUBSCRIBERS: 'Підписники',
      LIKES: 'Лайки',
      CHATBOTS: 'Чат-боти',
      YOU_HAVE_BLOCKED_THIS_AUTHOR: 'Ви заблокували цього автора. ',
      UNBLOCK: 'Розблокувати',
    },
    PROMPTS_BLOCK: {
      REPLACE: 'Замінити AI модель',
      SELECT: 'Вибрати AI модель',
    },
    FILE_UPLOAD: {
      UPLOAD: 'Завантажити',
    },
    SUBSCRIBE_BOOSTY: {
      CAN_SUBSCRIBE: 'Ви також можете оформити підписку через Boosty, який пропонує гнучкі варіанти для ваших потреб.',
      HAVE_SUBSCRIBE: 'У вас вже є підписка через Boosty. Ваша підписка дійсна до:',
      GO_TO_BOOSTY: 'Перейти до Boosty',
      SUBSCRIBE_TO_BOOSTY: 'Підписатися на Boosty',
      BACKEND_SUCCESSFULLY_NOTIFICATION: 'Email Boosty успішно прив’язано до вашого акаунта',
    },
    TAGS_SELECT: {
      TAGS: 'Теги',
      PLACEHOLDER: 'Позначте свого персонажа відповідними ключовими словами (максимум 10 тегів)',
      CREATE_NEW: 'Створити новий – {{tag}}',
      LIMIT: 'Максимум 10 тегів',
      CUSTOM_TAG_VALIDATION:
        'Користувацькі теги повинні містити від 3 до 20 символів і включати лише латинські літери (A–Z) та цифри (0–9)',
      ALREADY_SELECTED: 'Тег вже вибрано',
    },
    CHATBOT_PERSONA_SELECTOR: {
      ADD_NEW: 'Додати',
    },
    CHATBOT_PREVIOUS_CHATS: {
      PREVIOUS_CHATS: 'Ваші попередні чати:',
    },
    CHATBOT_INFORMATION_GREETINGS: {
      CHOOSE_FIRST_MESSAGE: 'Оберіть перше повідомлення:',
    },
    CHATBOT_INFORMATION_SCENARIO: {
      RECOMMENDED_LANG: 'Для коректної роботи чатбота рекомендується заповнювати англійською мовою',
    },
    REFERRAL: {
      MY_REFERRALS: 'Мої реферали',
      ACTIVE: 'Активні',
      LOST: 'Втрачені',
      NON_ACTIVE: 'Неактивні',
      TOTAL: 'Всього',
      CREATE_NEW_CAMPAIGN: 'Створити нову кампанію',
      NO_CAMPAIGNS: 'У вас ще немає створених кампаній',
      CREATE_FIRST_CAMPAIGN: 'Створіть свою першу кампанію та почніть заробляти.',
      CAMPAIGN_NAME: 'Назва кампанії',
      REFERRAL_CODE: 'Реферальний код',
      INVITE_CODE: 'Код',
      YOUR_REFERRAL_CODE: 'Ваш реферальний код',
      ACTIVATIONS: 'Активації',
      REFERRALS: 'Реферали',
      INCOME: 'Дохід',
      COPY_LINK: 'Скопіювати посилання',
      COPY_CODE_NOTIFICATION: 'Реферальний код успішно скопійовано',
      COPY_URL_NOTIFICATION: 'URL кампанії успішно скопійовано',
      START_DATE: 'Дата від',
      END_DATE: 'Дата до',
      CHART: {
        INCOME: 'Дохід',
        ACTIONS: 'Дії',
        REGISTRATIONS: 'Реєстрації',
        LINK_TRANSITIONS: 'Переходи',
        CODE_ACTIVATIONS: 'Активації',
      },
      TABS: {
        PLACEHOLDER: {
          TITLE: 'Наразі у вас немає історії рефералів',
          TIP: 'Поділіться своїм реферальним посиланням просто зараз',
          BUTTON: 'Скопіювати посилання',
        },
        STATISTICS: {
          TITLE: 'Статистика',
          DATE: 'Дата',
          CLICKS: 'Переходи',
          NEW_REFERRALS: 'Нові реферали',
          LOST: 'Втрачені',
          INCOME: 'Дохід',
          SAVE: 'Зберегти CSV',
        },
        TOP_REFERRALS: {
          TITLE: 'Топ реферали',
          USER: 'Користувач',
          REGISTRATION_DATE: 'Дата реєстрації',
          STATUS: 'Статус',
          STATUSES: {
            ACTIVE: 'Активний',
            INACTIVE: 'Неактивний',
            LOST: 'Втрачено',
          },
          INCOME: 'Дохід',
        },
        HISTORY: {
          TITLE: 'Історія',
          DATE: 'Дата',
          USER: 'Користувач',
          INCOME: 'Дохід',
          INFO: 'Інформація',
          COMMISSION: {
            PURCHASE: 'Комісія з покупки',
            SUBSCRIPTION: 'Комісія з підписки',
            USAGE: 'Комісія за використання',
            UNKNOWN: 'Комісія',
          },
        },
      },
      NOTIFICATIONS: {
        SUCCESS: 'Реферальний код успішно застосовано',
        OWN_CODE_ERROR: 'Ви не можете застосувати власний реферальний код',
        CAMPAIGN_NOT_ACTIVE: 'Ця кампанія не активна',
        CAMPAIGN_LIMIT: 'Неможливо створити більше 10 активних кампаній',
        COOLDOWN_NOT_EXPIRED: 'Реферальний код вже застосовано',
        SIGN_IN_TO_APPLY_CODE: 'Реферальний код збережено. Будь ласка, увійдіть, щоб застосувати його.',
        CODE_MUST_BE: 'Реферальний код повинен складатися рівно з 8 великих літер та цифр',
        CODE_INVALID: 'Реферальний код не знайдено або неактивний',
      },
    },
    PURCHASE_HISTORY: {
      DOWNLOAD: 'CSV файл',
      CSV: 'CSV',
      NO_HISTORY: 'У вас наразі немає історії покупок',
      TIP: 'Підпишіться або придбайте токени',
      BUTTON: 'Обрати тарифний план',
      INFO: 'Інфо',
      NAME: 'Назва',
      STATUS: 'Статус',
      CREATED_AT: 'Створено',
      AMOUNT: 'Сума',
      METHOD: 'Метод',
      MORE: 'Більше',
      DISPLAY_ROWS: 'Показувати рядки',
      NO_RESULTS: 'За вашим запитом нічого не знайдено',
      NO_RESULTS_TIP: 'Спробуйте змінити параметри пошуку',
      START_DATE: 'Від',
      END_DATE: 'До',
      FILTER: 'Фільтр',
      STATUSES: {
        ALL: 'Усі статуси',
        PENDING: 'Очікує',
        PROCESSING: 'Опрацьовується',
        COMPLETED: 'Завершено',
        FAILED: 'Не вдалося',
        REFUNDED: 'Повернено',
        CANCELLED: 'Скасовано',
      },
    },
    BALANCE_HISTORY: {
      WEEK: 'За тиждень',
      MONTH: 'За місяць',
      SOURCE: 'Джерело',
      COST_RATIO: 'Співвідношення витрат',
      EXPENSES: 'Витрати',
      NO_RESULT: 'Історія вашого балансу наразі порожня',
      TIP: 'Дані зʼявляться тут, коли ви почнете спілкуватися з ботами або генерувати зображення.',
      BUTTON: 'Обрати чат-бота',
      NO_RESULT_FOR_QUERY: 'За вашим запитом нічого не знайдено',
      TIP_FOR_QUERY: 'Спробуйте змінити параметри пошуку',
      SPEND_TYPE: {
        CHAT: 'Чат',
        IMAGE: 'Зображення',
        CUSTOM_AGENT: 'Користувацький агент',
        IMG_PROMPT_TUNER: 'Тюнінг промптів для зображень',
        AGENT: 'Агент',
        LORE_BOOK: 'Книга знань',
        MEMORIES: 'Спогади',
        SUGGESTION: 'Пропозиція',
        IMAGE_PROMPT: 'Промпт для зображення',
        IMAGE_DESCRIPTION: 'Опис зображення',
        AVATAR_NSFW_MODERATION: 'NSFW модерація аватара',
        CHARACTER_MODERATION: 'Модерація персонажа',
        PROMPT_MODERATION: 'Модерація промпта',
        IMAGE_AGE_MODERATION: 'Вікова модерація зображення',
      },
      IN: 'вх',
      OUT: 'вих',
      IMAGES: 'Зображення',
      CHATBOT_REMOVED: 'Чатбот видалено',
    },
    MONETIZATION: {
      TABS: {
        CHATBOTS: 'Чат-боти',
        BILLING: 'Білінг',
      },
      CHATBOTS: {
        PLACEHOLDER: 'Пошук за імʼям',
        INCOME: 'Дохід',
        WITHDRAWALS: 'Виведення коштів',
        CHATS: 'Чати',
        USERS: 'Користувачі',
        RANGE: {
          DAY: '1Д',
          THREE_DAYS: '3Д',
          WEEK: '1Т',
          MONTH: '1М',
          THREE_MONTHS: '3М',
          SIX_MONTHS: '6М',
          YEAR: '1Р',
          ALL: 'Усі',
        },
        EMPTY_PLACEHOLDER: {
          EARN: 'Заробляйте з AI-ботами',
          CREATE: 'Створіть свого першого бота та отримуйте відсоток від його доходу',
          NO_EARNING_BOT: 'Жоден із ваших ботів ще не приніс доходу',
          COME_BACK_LATER: 'Будь ласка, спробуйте повернутися сюди пізніше',
        },
        DISCLAIMER: 'Відображаються лише боти, які приносять дохід',
      },
      BILLING: {
        MY_BALANCE: 'Мій баланс',
        TOTAL_INCOME: 'Загальний дохід',
        REVENUE_AVAILABLE: 'Доступно до виведення',
        ONCE: 'Ви можете виводити кошти лише один раз протягом 24 годин',
        WITHDRAW_VIA: 'Вивести через',
        LAST_WITHDRAWAL: 'Останнє виведення',
        LEFT: 'залишилось',
        BLOCKED: 'Виведення заблоковано',
        UNLOCK_TIP: 'Щоб розблокувати виведення коштів, будь ласка, пройдіть процес KYC-верифікації.',
        KYC_VERIFICATION: 'KYC-верифікація',
        SECTION_UNDER_DEVELOPMENT: 'Тимчасово недоступно. Розділ у розробці.',
        PLACEHOLDER: {
          TITLE: 'Немає записів про виведення коштів',
          DESCRIPTION: 'Ваша історія виведення коштів наразі порожня',
        },
        TABLE: {
          NAME: 'Імʼя',
          STATUS: 'Статус',
          DATE: 'Дата',
          TIME: 'Час',
          INCOME: 'Дохід',
          INFO: 'Інфо',
          INVOICE: 'Рахунок',
        },
      },
    },
  },
  UTILS: {
    SMART_DATE_FORMAT: {
      JUST_NOW: 'Щойно',
      MINUTES_AGO: '{{count}} {{minutes}} тому',
      HOURS_AGO: '{{count}} {{hours}} тому',
      DAYS_AGO: '{{count}} {{days}} тому',
      WEEKS_AGO: '{{count}} {{weeks}} тому',
      MONTHS_AGO: '{{count}} {{months}} тому',
      ONE_MINUTES: 'хвилину',
      FEW_MINUTES: 'хвилини',
      MANY_MINUTES: 'хвилин',
      ONE_HOURS: 'годину',
      FEW_HOURS: 'години',
      MANY_HOURS: 'годин',
      ONE_DAYS: 'день',
      FEW_DAYS: 'дні',
      MANY_DAYS: 'днів',
      ONE_WEEK: 'тиждень',
      FEW_WEEKS: 'тижні',
      MANY_WEEKS: 'тижнів',
      ONE_MONTH: 'місяць',
      FEW_MONTHS: 'місяці',
      MANY_MONTHS: 'місяців',
    },
    SMART_MESSAGE_FORMAT: {
      ONE_MESSAGES: 'повідомлення',
      FEW_MESSAGES: 'повідомлення',
      MANY_MESSAGES: 'повідомлень',
    },
    TIME: {
      H: 'г',
      M: 'хв',
      S: 'с',
    },
  },
  NOTIFICATIONS: {
    CHATBOT_CREATE: {
      SUCCESS: 'Чат-бот "{{name}}" успішно створено!',
      UPDATE_SUCCESS: 'Чат-бот успішно оновлено!',
      UPDATE_ERROR: 'Помилка оновлення чат-бота!',
      REQUIRED_FIELDS: "Обов'язкові поля мають бути заповнені:",
    },
    CHAT_MESSAGE: {
      NEW_CHAT_STARTED: 'Нова розмова розпочата з обраного повідомлення!',
      ERROR: 'Під час обробки запиту сталася помилка',
      REPORT_MESSAGE_SENT: 'Ваша скарга надіслана',
      ENCRYPTION_SAVE: 'Ваші налаштування шифрування успішно збережено.',
      ENCRYPTION_DELETE: 'Шифрування скасовано.',
      ENCRYPTION_LIMIT:
        'Ви досягли ліміту зашифрованих чатів! Розшифруйте кілька чатів або оновіть свій тариф, щоб продовжити шифрувати нові.',
      COMPLAIN_WARNING:
        'У зашифрованих чатах неможливо надіслати скаргу або оцінити відповідь. Це необхідно для повного забезпечення конфіденційності вашего листування.',
      EMPTY_RESPONSE: 'Під час виконання запиту сталася помилка, будь ласка, спробуйте ще раз',
      RETRY: 'Повторити',
    },
    TEXT_TO_SPEECH_ERROR:
      'Ми не змогли отримати доступ до вашого мікрофона. Будь ласка, перевірте дозволи браузера або пристрою, щоб увімкнути перетворення мовлення в текст.',
    PASSWORD_CHANGED: 'Пароль успішно змінено',
    FAILED_TO_LOAD_IMAGE: 'Не вдалося завантажити зображення!',
    COPIED_TO_CLIPBOARD: 'Скопійовано в буфер обміну',
  },
  COMMON: {
    ADD: 'Додати',
    OR: 'або',
    AND: 'і',
    BY: 'від',
    FREE: 'БЕЗКОШТОВНО',
    EXAMPLE: 'Приклад',
    CONTINUE: 'Продовжити',
    CONFIRM: 'Підтвердити',
    DELETE: 'Видалити',
    DELETED: 'Видалено',
    SAVE: 'Зберегти',
    DONE: 'Готово',
    SUBMIT: 'Надіслати',
    REGENERATE: 'Згенерувати знову',
    GENERATE: 'Згенерувати',
    GENERATING: 'Генерується',
    GENERATION: 'Генерація...',
    REFILL_BALANCE: 'Поповнити баланс',
    DISCOUNT: '{{percent}}% Знижка',
    CREATE: 'Створити',
    CANCEL: 'Скасувати',
    COPY: 'Копіювати',
    COPIED: 'Скопійовано',
    BACK: 'Назад',
    LOG_IN: 'Увійти',
    SIGN_IN: 'Авторизуватися',
    SIGN_UP: 'Зареєструватися',
    SIGN_UP_WITH: 'Зареєструватися через {{ provider }}',
    PASSWORD: 'Пароль',
    CONFIRM_PASSWORD: 'Підтвердіть пароль',
    NOT_AVAILABLE: 'Недоступно',
    CLOSE: 'Закрити',
    PAUSE: 'Пауза',
    PLAY: 'Відтворити',
    STOP: 'Зупинити',
    MIN: 'Мін',
    MAX: 'Макс',
    WARNING: 'Попередження',
    INFO: 'Інформація',
    ERROR: 'Помилка',
    SUCCESS: 'Успіх',
    APPLIED: 'Застосовано',
    START: 'Старт',
    LOADING: 'Завантаження...',
    PLACEHOLDER: {
      SEARCH: 'Пошук...',
    },
    FILE_INPUT: {
      INVALID_FILE_TYPE: 'Файл {{fileName}} має недопустимий тип. Дозволені типи: {{allowedTypes}}',
      INVALID_FILE_TYPE_SHORT: 'Дозволені: {{allowedTypes}}',
      MAX_FILE_SIZE: 'Файл {{fileName}} має бути меншим за {{maxSize}}МБ',
      DRAG_AND_DROP_TO_UPLOAD_IMAGE: 'Перетягніть або натисніть, щоб завантажити зображення',
      DROP_FILE: 'Перетягніть файл сюди',
      CHOOSE_FILE: 'Вибрати файл',
    },
    ERRORS: {
      INVALID_FIELD: 'Поле неприпустиме',
      FILLED_IN: 'Поле має бути заповнене',
      MIN_LENGTH: 'Мінімальна довжина — {{length}} символів',
      MAX_LENGTH: 'Максимальна довжина — {{length}} символів',
      NO_SPACES: 'Поле не може починатися, закінчуватися або складатися лише з пробілів',
      INVALID_EMAIL: 'Невірна адреса електронної пошти',
      INVALID_CURRENT_PASSWORD: 'Поточний пароль недійсний',
      PASS_NOT_CHANGED: 'Новий пароль має відрізнятися від старого',
      INVALID_USERNAME: 'Невірне ім’я користувача',
      INVALID_USERNAME_EXPANDED:
        'Імʼя користувача має бути від 3 до 20 символів і може містити лише латинські літери (a–z), цифри та дефіси',
      DUMB_ERROR: 'Щось пішло не так',
      PASSWORD_MISMATCH: 'Паролі не збігаються',
      INVALID_PASSWORD:
        'Довжина пароля повинна бути від {{minLength}} до {{maxLength}} символів. Дозволені лише A-Z, a-z, 0-9 та спеціальні символи.',
      INVALID_PASS: 'Невірний пароль',
      INVALID_EMAIL_OR_PASSWORD: 'Невірна пошта або пароль',
      FIELD_BETWEEN: 'Довжина повинна бути від {{minLength}} до {{maxLength}} символів.',
      VALUE_MUST_BE_BETWEEN: 'Значення має бути між {{min}} та {{max}}',
      LOADING_ERROR: 'Помилка завантаження',
      NOT_ENOUGH_TOKENS: 'У вас недостатньо токенів для генерації зображення. Будь ласка, поповніть свій акаунт.',
      NO_ITEMS_AVAILABLE: 'Немає доступних елементів',
      SPEECH_RECOGNITION_NOT_SUPPORTED: 'API розпізнавання мовлення не підтримується в цьому браузері.',
    },
    MONTH: {
      JANUARY: 'Січень',
      FEBRUARY: 'Лютий',
      MARCH: 'Березень',
      APRIL: 'Квітень',
      MAY: 'Травень',
      JUNE: 'Червень',
      JULY: 'Липень',
      AUGUST: 'Серпень',
      SEPTEMBER: 'Вересень',
      OCTOBER: 'Жовтень',
      NOVEMBER: 'Листопад',
      DECEMBER: 'Грудень',
    },
    WEEK: {
      MONDAY: 'Пн',
      TUESDAY: 'Вт',
      WEDNESDAY: 'Ср',
      THURSDAY: 'Чт',
      FRIDAY: 'Пт',
      SATURDAY: 'Сб',
      SUNDAY: 'Нд',
    },
    SHOW: 'Показати',
    HIDE: 'Приховати',
    DISABLE: 'Вимкнути',
    ENABLE: 'Увімкнути',
    DENY: 'Заборонити',
    ALLOW: 'Дозволити',
    MORE: 'Більше',
    LESS: 'Менше',
  },
  FAQ: {
    TOPIC1: {
      QUESTION: 'Як працює зміна плану підписки?',
      ANSWER:
        'Зміна плану підписки доступна в будь-який момент: При переході на вищий рівень — активація відбувається одразу після оплати різниці за час, що залишився. При переході на нижчий — активація відбудеться після закінчення поточного періоду.',
    },
    TOPIC2: {
      QUESTION: 'Чи згоряє бонусна енергія після закінчення підписки?',
      ANSWER:
        'Ні, бонусна енергія не згоряє — ви можете продовжувати використовувати її навіть після закінчення підписки. Коли ви оформите нову підписку, вам буде нарахована нова порція бонусної енергії.',
    },
    TOPIC3: {
      QUESTION: 'Чи продовжується підписка автоматично?',
      ANSWER:
        'Так, підписка продовжується автоматично для вашої зручності, щоб ви не втрачали доступ до функцій. Але ви можете скасувати автопродовження в будь-який момент через налаштування. При цьому доступ до можливостей підписки збережеться до кінця оплаченого періоду.',
    },
    TOPIC4: {
      QUESTION: 'Залишились ще питання?',
      ANSWER: 'Якщо вам потрібна допомога, зверніться до нашої служби підтримки за адресою {{email}}.',
      BUTTON: 'Поставити запитання в Discord',
    },
  },
  FAQ_PROFILE: {
    TOPIC1: {
      QUESTION: 'Чи можу я оновити або знизити свій тарифний план?',
      ANSWER:
        'Текст буде доступний найближчим часом. Якщо у вас виникли запитання, будь ласка, зв’яжіться з нами за адресою support@caichat.ai',
    },
    TOPIC2: {
      QUESTION: 'Як скасувати мій тарифний план?',
      ANSWER:
        'Текст буде доступний найближчим часом. Якщо у вас виникли запитання, будь ласка, зв’яжіться з нами за адресою support@caichat.ai',
    },
    TOPIC3: {
      QUESTION: 'Чи можу я скасувати підписку та зберегти переваги плану до кінця поточного розрахункового циклу?',
      ANSWER:
        'Текст буде доступний найближчим часом. Якщо у вас виникли запитання, будь ласка, зв’яжіться з нами за адресою support@caichat.ai',
    },
    TOPIC4: {
      QUESTION: 'Як отримати відшкодування?',
      ANSWER:
        'Текст буде доступний найближчим часом. Якщо у вас виникли запитання, будь ласка, зв’яжіться з нами за адресою support@caichat.ai',
    },
    TOPIC5: {
      QUESTION: 'У мене є додаткові запитання.',
      ANSWER: 'Якщо вам потрібна допомога, натисніть кнопку нижче. Наша служба підтримки завжди готова відповісти на ваші запитання.',
      BUTTON: 'Задати питання',
    },
  },
  OAUTH_CANNOT_DISCONNECT_LAST_ACCOUNT:
    'Неможливо відключити останній привʼязаний акаунт. Принаймні один акаунт має залишатися підключеним.',
  BACKEND_MESSAGES: {
    INVALID_PASSWORD: 'Невірний пароль',
    SLUG_ALREADY_TAKEN: 'Імʼя користувача {{slug}} вже зайняте іншим користувачем',
    TOKENS_EXCEEDED:
      'Обрана модель недоступна для цього персонажа. Безкоштовні моделі заблоковані для цього персонажа. Загальний контекст ({{number}} токенів) перевищує ліміт (5000). Будь ласка, використовуйте платну модель.',
    NOT_ENOUGH_TOKENS: 'У вас недостатньо токенів, щоб згенерувати це зображення',
    ALREADY_REPORT_USER: 'Ви вже поскаржилися на цього користувача',
    PAYMENT_PROVIDER: {
      NO_PAYMENT_SYSTEMS: 'Помилка платіжного провайдера: Немає доступних платіжних систем',
      BETATRANSFER_ERROR: 'Помилка платіжного провайдера: Невідома помилка від BetaTransfer',
    },
    CANNOT_CREATE_CHAT_WITH_PAID_MODEL:
      'Неможливо створити чат із платною моделлю. Для використання платних моделей вам потрібні токени або активна платна підписка.',
    TRANSACTION_ID_NOT_FOUND: 'Транзакцію з ID {{id}} не знайдено',
  },
  SEO: {
    HOME_TITLE: 'Дівчина ШІ: Переписка з аніме-тянкою (Чарактер АІ) без цензури',
    HOME_DESCRIPTION:
      'Спілкуйтеся з віртуальною дівчиною у форматі листування або створюйте власних персонажів ШІ. Аніме-чат із реалістичними діалогами без цензури та фільтра онлайн.',

    CATALOG_TITLE: 'Каталог персонажів ШІ: Спілкування з аніме персонажами в Спайсі чаті',
    CATALOG_DESCRIPTION:
      'Переглядайте каталог персонажів ШІ та починайте спілкування онлайн. Аніме персонажі й унікальні характери для реалістичних діалогів.',

    SUBSCRIBE_TITLE: 'Підписка та токени: Преміум тарифи CAICHAT',
    SUBSCRIBE_DESCRIPTION:
      'Оберіть тарифний план або придбайте токени для доступу до преміум-функцій. Порівняйте можливості підписки та покращіть свій досвід спілкування.',

    HELP_TITLE: 'Допомога та інструкції: Підтримка CAICHAT',
    HELP_DESCRIPTION:
      'Інструкції та поради щодо використання CAICHAT. Дізнайтеся, як налаштувати профіль, створювати персонажів, використовувати токени та керувати параметрами чату.',

    TERMS_TITLE: 'Умови використання — CAICHAT',
    TERMS_DESCRIPTION: 'Ознайомтеся з умовами користування CAICHAT, правами та обов’язками користувачів і юридичною інформацією.',

    PRIVACY_TITLE: 'Політика конфіденційності — CAICHAT',
    PRIVACY_DESCRIPTION: 'Дізнайтеся, як CAICHAT збирає, використовує та захищає персональні дані користувачів.',

    REFUND_TITLE: 'Політика повернення коштів — CAICHAT',
    REFUND_DESCRIPTION: 'Ознайомтеся з умовами повернення коштів та процедурою подання запиту на повернення.',

    BLOCKED_CONTENT_TITLE: 'Політика обмеженого контенту — CAICHAT',
    BLOCKED_CONTENT_DESCRIPTION: 'Дізнайтеся, який контент обмежений або заборонений на платформі CAICHAT.',

    COMMUNITY_TITLE: 'Правила спільноти — CAICHAT',
    COMMUNITY_DESCRIPTION: 'Ознайомтеся з правилами спільноти CAICHAT та стандартами допустимої поведінки.',

    CONTENT_REMOVAL_TITLE: 'Політика видалення контенту — CAICHAT',
    CONTENT_REMOVAL_DESCRIPTION: 'Дізнайтеся, як CAICHAT розглядає запити на видалення користувацького контенту.',

    UNDERAGE_TITLE: 'Політика захисту неповнолітніх — CAICHAT',
    UNDERAGE_DESCRIPTION: 'Ознайомтеся з віковими вимогами та заходами захисту неповнолітніх на платформі CAICHAT.',
  },
};
